// Angular
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// Libs
import { BsModalRef } from 'ngx-bootstrap/modal';
// Services
import { SessionService } from '@core/services-v2/session/session.service';
import { SessionStorageService } from '@core/storage/session-storage.service';
// Models
import { ISession } from '@core/models-v2/auth/session.interface';
import { IConfig } from '@core/config/config.interface';
// Libs
import { ToastrService } from 'ngx-toastr';
import { CustomerService } from '@core/services-v2/customer.service';
import { ConfigService } from '@core/config/config.service';

@Component({
  selector: 'app-edit-profile-modal',
  templateUrl: './edit-profile-modal.component.html',
  styleUrls: ['./edit-profile-modal.component.scss'],
})
export class EditProfileModalComponent {
  @Input() modalEditRef!: BsModalRef;
  @Output() respuesta = new EventEmitter<boolean>();

  formProfile!: FormGroup;
  session: ISession;
  config: IConfig;
  selectedPhoneCode: string;
  phoneLength: number;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    // Services V2
    private readonly sessionService: SessionService,
    private readonly sessionStorage: SessionStorageService,
    private readonly customerService: CustomerService,
    private readonly configService: ConfigService
  ) {
    this.config = this.configService.getConfig();
    this.session = this.sessionService.getSession();
    this.selectedPhoneCode = this.config.phoneCodes.mobile.code;
    this.phoneLength = this.config.phoneCodes.mobile.lengthRule;
    this.buildForm(this.session);
  }

  private buildForm({ firstName, lastName, phone, email }: ISession): void {
    let phoneEdit = '';
    let phoneNumber = phone?.slice(-this.phoneLength);
    let codePhone = phone?.slice(0, this.selectedPhoneCode.length);
    if (codePhone === this.selectedPhoneCode) phoneEdit = phoneNumber || '';
    else phoneEdit = phone || '';
    this.formProfile = this.fb.group({
      firstName: [firstName, [Validators.required]],
      lastName: [lastName, [Validators.required]],
      email: [email, [Validators.required]],
      phone: [
        phoneEdit,
        [Validators.required, Validators.pattern('[1-9][0-9]{0,9}')],
      ],
    });
  }

  updateProfile(): void {
    const { firstName, lastName, email, phone } = this.formProfile.value;
    let phoneComplete = this.selectedPhoneCode + phone;
    this.customerService
      .updateProfile({
        documentId: this.session.documentId,
        firstName,
        lastName,
        email,
        phoneComplete,
      })
      .subscribe({
        next: () => {
          this.toastr.success('Se actualizo con exito los datos');
          this.sessionStorage.set({
            ...this.session,
            firstName,
            lastName,
            phone: phoneComplete,
            email,
          });
          this.respuesta.emit(true);
          this.modalEditRef.hide();
        },
        error: () => {
          this.toastr.error('No se logro actualizar el perfil');
          this.respuesta.emit(false);
        },
      });
  }

  noCharPhone(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
    this.formProfile.controls['phone'].setValue(input.value);
  }

  selectPhoneCode(phoneCode: string): void {
    this.selectedPhoneCode = phoneCode;
    this.phoneLength =
      this.selectedPhoneCode === this.config.phoneCodes.mobile.code
        ? this.config.phoneCodes.mobile.lengthRule
        : this.config.phoneCodes.landline.lengthRule;

    this.formProfile.controls['phone'].setValidators([
      Validators.required,
      Validators.minLength(this.phoneLength),
      Validators.maxLength(this.phoneLength),
    ]);
    this.formProfile.get('phone')?.updateValueAndValidity();
  }
}
